module.exports = __webpack_public_path__ + "static/media/skilldizer.1838ab37.webp";